// @flow

import { useTranslator } from '@gandi/translate';

import type { DomainProduct } from '../types';

import { PriceAndCartButton } from './PriceAndCartButton';
import { ResultRow } from './ResultRow';

type Props = {
  result: DomainProduct,
};

export const CreatableResult = ({ result }: Props): React.MixedElement => {
  const { __ } = useTranslator();

  return (
    <ResultRow
      iconName="available_secondary"
      statusText={__('Create')}
      fqdn={result.fqdn}
      pricingBlock={
        <PriceAndCartButton
          result={result}
          addToCartButtonLabel={__('Register')}
          process="create"
        />
      }
    />
  );
};
